import { Box, Card, Flex, Heading, Image } from "@chakra-ui/react";
import type { ReactElement, ReactNode } from "react";
import Logo from "./assets/images/logo.png";

export default function FullScreenMessage(p: {
    children?: ReactNode;
    icon?: ReactNode;
    label?: ReactNode;
}): ReactElement {
    return (
        <Flex
            minH="100vh"
            bg="green.500"
            align="center"
            justify="center"
            w="100%"
            overflow="hidden"
            px={4}
        >
            <Card.Root maxW="370px" w="full" bg="white" borderRadius="16px">
                <Card.Body
                    p={{ base: 6, md: 10 }}
                    display="flex"
                    flexDirection="column"
                    gap={5}
                >
                    <Box textAlign="center" mb={2}>
                        <Image src={Logo} w={200} mx="auto" />
                    </Box>

                    {p.children ?? (
                        <>
                            <Box>{p.icon}</Box>
                            <Heading
                                size="md"
                                textAlign="center"
                                fontWeight="semibold"
                                color="gray.800"
                            >
                                {p.label}
                            </Heading>
                        </>
                    )}
                </Card.Body>
            </Card.Root>
        </Flex>
    );
}
